/*
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2022-08-23 10:56:54
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-01-26 14:17:35
 * @FilePath: /wemeet-iam/Users/hvv/weMeetSpace/WeMeet_admin_project/wemeet-admin/src/views/form/config.js
 * @Description:
 * Copyright (c) 2024 by WeMeet, All Rights Reserved.
 */
/**
 * @name 自定义表单数据类型
 * name: 类型名称
 * type: 表单类型
 * label: 表单名称
 * required: 必填
 * rulesConfig 正则表达式类型，前端预设
 * value: 用户手动填写内容
 * rules: 自定义校验规则内容
 * rules.required  是否必填
 * rules.validator 自定义校验规则
 * rules.message 消息提示
 * child 选择器子选项
 * */

export const modelData = [
  {
    name: '输入框',
    type: 'input',
    icon: 'https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/MEHZ/admin/img/input.png',
    label: '',
    required: true,
    isSearch: false,
    value: '',
    rulesConfig: '',
    message: '',
    rules: [],
  },
  {
    name: '数字输入框',
    type: 'numberInput',
    icon: 'https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/MEHZ/admin/img/numberInput.png',
    label: '',
    required: true,
    isSearch: false,
    value: '',
    rulesConfig: '',
    message: '',
    rules: [],
  },

  {
    name: '文本域',
    type: 'textarea',
    icon: 'https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/MEHZ/admin/img/input.png',
    label: '',
    required: true,
    value: '',
    isSearch: false,
    rulesConfig: '',
    maxLength: 0,
    message: '',
    rules: [],
  },
  {
    name: '单选框',
    type: 'radio',
    icon: 'https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/MEHZ/admin/img/radio.png',
    label: '',
    required: true,
    value: '',
    isSearch: false,
    rulesConfig: '',
    message: '',
    rules: [
      {
        required: true,
        validator: '',
        message: '',
      },
    ],
    child: [
      {
        label: '',
        type: 'normal',
      },
      {
        label: '',
        type: 'normal',
      },
    ],
  },
  {
    name: '多选框',
    icon: 'https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/MEHZ/admin/img/checkbox.png',
    type: 'checkBox',
    label: '',
    required: true,
    value: [],
    rulesConfig: '',
    isSearch: false,
    message: '',
    rules: [
      {
        required: true,
        validator: '',
        message: '',
      },
    ],
    child: [
      {
        label: '',
        type: 'normal',
      },
      {
        label: '',
        type: 'normal',
      },
    ],
  },
  {
    name: '时间选择器',
    icon: 'https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/MEHZ/admin/img/timePicker.png',
    type: 'timePicker',
    label: '',
    required: true,
    value: '',
    isSearch: false,
    rulesConfig: '',
    message: '',
    rules: [
      {
        required: true,
        validator: '',
        message: '',
      },
    ],
    child: [],
  },
  {
    name: '下拉框',
    icon: 'https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/MEHZ/admin/img/selectPicker.png',
    type: 'select',
    label: '',
    required: true,
    isSearch: false,
    value: '',
    rulesConfig: '',
    message: '',
    rules: [
      {
        required: true,
        validator: '',
        message: '',
      },
    ],
    child: [
      {
        label: '',
        type: 'normal',
      },
      {
        label: '',
        type: 'normal',
      },
    ],
  },
  {
    name: '展商选择器',
    icon: 'https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/MEHZ/admin/img/selectPicker.png',
    type: 'exh_customized',
    label: '展商选择器',
    required: true,
    isSearch: false,
    value: '',
    rulesConfig: '',
    message: '请选择展商',
    rules: [
      {
        required: true,
        validator: '',
        message: '',
      },
    ],
    child: [
      {
        label: '',
        type: 'normal',
      },
      {
        label: '',
        type: 'normal',
      },
    ],
  },
  {
    name: '团组选择器',
    icon: 'https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/MEHZ/admin/img/selectPicker.png',
    type: 'group_customized',
    label: '团组选择器',
    required: true,
    isSearch: false,
    value: '',
    rulesConfig: '',
    message: '请选择团组',
    rules: [
      {
        required: true,
        validator: '',
        message: '',
      },
    ],
    child: [
      {
        label: '',
        type: 'normal',
      },
      {
        label: '',
        type: 'normal',
      },
    ],
  },
]
